/* Fidgetsmith — minimal theme behaviour. No frameworks, no shouting. */
(function () {
  'use strict';

  /* Sheets — nav and filters slide in behind the chrome ------------------ */
  var lastFocus = null;

  function openSheet(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusable = sheet.querySelector('.sheet__row, [data-sheet-close]');
    if (focusable) focusable.focus();
  }

  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sheet-open]');
    if (opener) {
      e.preventDefault();
      openSheet(opener.getAttribute('data-sheet-open'));
      return;
    }
    if (e.target.closest('[data-sheet-close]') || e.target.matches('.sheet__scrim')) {
      closeSheet(e.target.closest('.sheet'));
    }
  });

  /* Nav sheet drill-downs */
  document.addEventListener('click', function (e) {
    var row = e.target.closest('[data-sheet-row]');
    if (!row) return;
    var sub = document.getElementById(row.getAttribute('aria-controls'));
    if (!sub) return;
    var open = sub.classList.toggle('is-open');
    row.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.sheet.is-open');
      if (open) closeSheet(open);
    }
  });

  /* Product gallery ----------------------------------------------------- */
  function gallerySelect(wrap, index) {
    var thumbs = wrap.querySelectorAll('[data-gallery-thumb]');
    if (!thumbs.length) return;
    var i = ((index % thumbs.length) + thumbs.length) % thumbs.length;
    var thumb = thumbs[i];
    var main = wrap.querySelector('[data-gallery-main]');
    var src = thumb.getAttribute('data-src');
    if (main && src) {
      main.setAttribute('src', src);
      main.setAttribute('srcset', '');
    }
    thumbs.forEach(function (t, n) {
      t.setAttribute('aria-current', n === i ? 'true' : 'false');
    });
    var dots = wrap.querySelectorAll('[data-gallery-dots] span');
    dots.forEach(function (d, n) {
      d.classList.toggle('is-active', n === i);
    });
    wrap.setAttribute('data-gallery-index', i);
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var wrap = thumb.closest('[data-gallery]');
      if (!wrap) return;
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-gallery-thumb]'));
      gallerySelect(wrap, thumbs.indexOf(thumb));
      return;
    }
    var step = e.target.closest('[data-gallery-step]');
    if (step) {
      var w = step.closest('[data-gallery]');
      if (!w) return;
      var current = parseInt(w.getAttribute('data-gallery-index') || '0', 10);
      gallerySelect(w, current + parseInt(step.getAttribute('data-gallery-step'), 10));
    }
  });

  /* Variant selection --------------------------------------------------- */
  function initVariants(form) {
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-variant-price]');
    var comparEl = form.querySelector('[data-variant-compare]');
    var submit = form.querySelector('[data-add-button]');
    var moneyFormat = form.getAttribute('data-money-format') || '{{amount}}';

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      // Strip trailing .00 the way the design does (£89, not £89.00)
      if (amount.indexOf('.00') === amount.length - 3) amount = amount.slice(0, -3);
      return moneyFormat.replace('{{amount}}', amount);
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.filter(function (v) {
        return chosen.every(function (opt, i) {
          return opt === null || v.options[i] === opt;
        });
      })[0];

      form.querySelectorAll('.variant-row').forEach(function (row) {
        var input = row.querySelector('input');
        row.classList.toggle('is-selected', !!(input && input.checked));
      });

      if (!match) {
        if (submit) { submit.setAttribute('disabled', 'disabled'); submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (comparEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparEl.textContent = money(match.compare_at_price);
          comparEl.hidden = false;
        } else {
          comparEl.hidden = true;
        }
      }
      if (submit) {
        if (match.available) {
          submit.removeAttribute('disabled');
          submit.textContent = 'Add to cart — ' + money(match.price);
        } else {
          submit.setAttribute('disabled', 'disabled');
          submit.textContent = 'Sold out';
        }
      }
    }

    form.addEventListener('change', update);
    update();
  }

  document.querySelectorAll('[data-product-form]').forEach(initVariants);

  /* Sticky buy bar — shows once the real add-to-cart scrolls away -------- */
  (function () {
    var bar = document.querySelector('[data-buybar]');
    var anchor = document.querySelector('[data-add-button]');
    if (!bar || !anchor) return;

    document.body.classList.add('has-buybar');

    var barBtn = bar.querySelector('[data-buybar-add]');
    if (barBtn) barBtn.dataset.label = barBtn.textContent.trim();
    if (barBtn) {
      barBtn.addEventListener('click', function () {
        var form = anchor.closest('form');
        if (form) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }
      });
    }

    function sync() {
      if (barBtn && anchor) {
        barBtn.disabled = anchor.disabled;
        barBtn.textContent = anchor.disabled ? anchor.textContent.trim() : barBtn.dataset.label;
      }
      var price = document.querySelector('[data-variant-price]');
      var barPrice = bar.querySelector('[data-buybar-price]');
      if (price && barPrice) barPrice.textContent = price.textContent;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -20% 0px' }).observe(anchor);
    } else {
      bar.classList.add('is-visible');
    }

    var form = anchor.closest('form');
    if (form) form.addEventListener('change', function () { setTimeout(sync, 0); });
    sync();
  })();

  /* Cart quantity steppers ---------------------------------------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(0, next);
    var form = input.closest('form');
    if (form) form.submit();
  });
})();


/* ---------- Light / dark mode ---------- */
(function () {
  var root = document.documentElement;
  function apply(mode) {
    if (mode === 'light') { root.setAttribute('data-theme', 'light'); }
    else { root.removeAttribute('data-theme'); }
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
    });
  }
  var saved;
  try { saved = localStorage.getItem('fs-theme'); } catch (e) {}
  apply(saved || 'dark');

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    e.preventDefault();
    var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
    apply(next);
    try { localStorage.setItem('fs-theme', next); } catch (err) {}
  });
})();


/* ---------- Desktop mega menu ---------- */
(function () {
  var toggles = document.querySelectorAll('[data-mega-toggle]');
  if (!toggles.length) return;

  function panelFor(key) { return document.querySelector('[data-mega="' + key + '"]'); }

  function closeAll(except) {
    document.querySelectorAll('[data-mega]').forEach(function (p) {
      if (p !== except) p.hidden = true;
    });
    toggles.forEach(function (t) {
      if (!except || t.getAttribute('data-mega-toggle') !== except.getAttribute('data-mega')) {
        t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var panel = panelFor(btn.getAttribute('data-mega-toggle'));
      if (!panel) return;
      var willOpen = panel.hidden;
      closeAll(willOpen ? panel : null);
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mega]') || e.target.closest('[data-mega-toggle]')) return;
    closeAll();
  });
})();


/* ---------- Search modal ---------- */
(function () {
  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;
  var input = modal.querySelector('[data-search-input]');

  function open() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (input) setTimeout(function () { input.focus(); }, 30);
  }
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }
    var tab = e.target.closest('[data-search-tab]');
    if (tab) {
      var key = tab.getAttribute('data-search-tab');
      modal.querySelectorAll('[data-search-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      modal.querySelectorAll('[data-search-pane]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-search-pane') === key);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });
})();


/* ---------- Marquee: keep the animated element small enough for iOS ----------
   Safari drops compositor animations when an element exceeds the GPU texture
   limit (width x devicePixelRatio). We clone only as many groups as are needed
   to cover 2x the container, keeping the count even so -50% loops seamlessly. */
(function () {
  var tracks = document.querySelectorAll('.marquee__track');
  if (!tracks.length) return;

  function build(track) {
    var container = track.parentElement;
    var groups = track.querySelectorAll('.marquee__group');
    if (!groups.length) return;

    // reset to a single source group
    for (var i = groups.length - 1; i > 0; i--) groups[i].remove();
    var source = track.querySelector('.marquee__group');
    var groupWidth = source.getBoundingClientRect().width;
    if (!groupWidth) return;

    var needed = Math.ceil((container.getBoundingClientRect().width * 2) / groupWidth);
    if (needed < 2) needed = 2;
    if (needed % 2 !== 0) needed += 1;

    for (var j = 1; j < needed; j++) {
      var clone = source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
    track.style.setProperty('--marquee-shift', '-' + (100 / needed) * (needed / 2) + '%');
  }

  tracks.forEach(build);

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { tracks.forEach(build); }, 250);
  });
})();


/* ---------- Cart bottom bar ---------- */
(function () {
  var bar = document.querySelector('[data-cartbar]');
  if (!bar) return;
  document.body.classList.add('has-cartbar');
  var btn = bar.querySelector('[data-cartbar-checkout]');
  var real = document.querySelector('[data-cart-checkout]');
  if (btn && real) {
    btn.addEventListener('click', function () {
      var form = real.closest('form');
      if (form) {
        real.click();
      }
    });
  }
})();
